import AbstractShape, {Dimensions, DimensionProperties} from "./AbstractShape";
import Length from "../../../../source/js/shared/models/Geometry/Length";
import DimensionLine from "@/Models/Lines/DimensionLine";

export class Droplet extends AbstractShape {

	constructor( dimensions?: object ) {
		super( 'droplet', dimensions );
	}

	getHeight(): Length {
		return this.cleanedPrimitives.height;
	}

	getLength(): Length {
		return this.cleanedPrimitives.height;
	}

	getWidth(): Length {
		return this.cleanedPrimitives.width;
	}

	getDimensionProperties(): DimensionProperties {
		return { primary: 'height', secondary: 'width' };
	}

	getDimensionLines(ratio = 1, focusedElement = '', forceRender = false): DimensionLine[] {
		if(focusedElement.includes("cutout_measurement") || forceRender) {
			return [
				new DimensionLine([0, 0], [0, this.getHeight().in_mm()], this.renderDimensionLabel('height'), [-40, 0], ratio, this.getDimensionLineType('measurements-droplet-height', focusedElement, forceRender)),
				new DimensionLine([0, 0], [this.getWidth().in_mm(), 0], this.renderDimensionLabel('width'), [0, -40], ratio, this.getDimensionLineType('measurements-droplet-width', focusedElement, forceRender)),
			];
		}

		return [];
	}

	getDefaultDimensions(): Dimensions {
		return {
			height: 80,
			width: 50
		};
	}

	getDefaultCutoutDimensions(parentShape: AbstractShape): Dimensions {
		const enclosingRectangle = parentShape.getEnclosingRectangle();
		const height = enclosingRectangle.height();

		return {
			height: height.divide(2).in_cm(),
			width: height.divide(4).in_cm(),
		};
	}
}
